import React from 'react'

const ActionBarModuleComp = (props) => {
    return (
        <>
            <div className="d-flex align-items-center py-1">
                {/*begin::Wrapper*/}
                <div className="me-4">
                    <div className="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true" id="kt_menu_615c3b188f30c">
                        {/*begin::Header*/}
                        <div className="px-7 py-5">
                            <div className="fs-5 text-dark fw-bolder">Filter Options</div>
                        </div>
                        {/*end::Header*/}
                        {/*begin::Menu separator*/}
                        <div className="separator border-gray-200" />
                        {/*end::Menu separator*/}
                        {/*begin::Form*/}
                        <div className="px-7 py-5">
                            {/*begin::Input group*/}
                            <div className="mb-10">
                                {/*begin::Label*/}
                                <label className="form-label fw-bold">Status:</label>
                                {/*end::Label*/}
                                {/*begin::Input*/}
                                <div>
                                    <select className="form-select form-select-solid" data-kt-select2="true" data-placeholder="Select option" data-dropdown-parent="#kt_menu_615c3b188f30c" data-allow-clear="true">
                                        <option />
                                        <option value={1}>Approved</option>
                                        <option value={2}>Pending</option>
                                        <option value={2}>In Process</option>
                                        <option value={2}>Rejected</option>
                                    </select>
                                </div>
                                {/*end::Input*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Input group*/}
                            <div className="mb-10">
                                {/*begin::Label*/}
                                <label className="form-label fw-bold">Member Type:</label>
                                {/*end::Label*/}
                                {/*begin::Options*/}
                                <div className="d-flex">
                                    {/*begin::Options*/}
                                    <label className="form-check form-check-sm form-check-custom form-check-solid me-5">
                                        <input className="form-check-input" type="checkbox" defaultValue={1} />
                                        <span className="form-check-label">Author</span>
                                    </label>
                                    {/*end::Options*/}
                                    {/*begin::Options*/}
                                    <label className="form-check form-check-sm form-check-custom form-check-solid">
                                        <input className="form-check-input" type="checkbox" defaultValue={2} defaultChecked="checked" />
                                        <span className="form-check-label">Customer</span>
                                    </label>
                                    {/*end::Options*/}
                                </div>
                                {/*end::Options*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Input group*/}
                            <div className="mb-10">
                                {/*begin::Label*/}
                                <label className="form-label fw-bold">Notifications:</label>
                                {/*end::Label*/}
                                {/*begin::Switch*/}
                                <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                                    <input className="form-check-input" type="checkbox" defaultValue name="notifications" defaultChecked="checked" />
                                    <label className="form-check-label">Enabled</label>
                                </div>
                                {/*end::Switch*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Actions*/}
                            <div className="d-flex justify-content-end">
                                <button type="reset" className="btn btn-sm btn-light btn-active-light-primary me-2" data-kt-menu-dismiss="true">Reset</button>
                                <button type="submit" className="btn btn-sm btn-primary" data-kt-menu-dismiss="true">Apply</button>
                            </div>
                            {/*end::Actions*/}
                        </div>
                        {/*end::Form*/}
                    </div>
                    {/*end::Menu 1*/}
                    {/*end::Menu*/}
                </div>
                {/*end::Wrapper*/}
                {/*begin::Button*/}
                <a onClick={() => props.showFormAdd()} className="btn btn-sm btn-primary">Tambah Modul</a>
                {/*end::Button*/}
            </div>
        </>
    )
}

export default ActionBarModuleComp
